import { JsonProperty } from "../requests/jsonparser";
import { Curated } from "./curated";
import CuratedCategory from "./curated_category";

export class CuratedSet {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'CuratedSet' })
    MODELNAME: string;

    @JsonProperty({ clazz: CuratedCategory, type: 'CuratedCategory' })
    categories: CuratedCategory[]

    @JsonProperty({ clazz: Curated, type: 'Curated' })
    featured: Curated[]
}



// WEBPACK FOOTER //
// ./src/api/src/models/curated_set.ts